import { Select, type SelectOption } from '@ph-react-ui/core';
import { useTranslation } from 'react-i18next';
import { useMatch, useSearchParams } from 'react-router-dom';
import { PaymentSchemesStatus } from '../../utils/enums/payment-schemes-status.enum';
import { SearchInput } from '../shared/components/SearchByNameInput';

export function PaymentSchemesFilter() {
  const { t } = useTranslation();
  const match = useMatch('/dashboard/payment-schemes');
  const [searchParams, setSearchParams] = useSearchParams();

  const statusOptions: SelectOption<number | string>[] = [
    {
      label: t(`PAYMENT_SCHEMES.TABLE.STATUS.ACTIVE`),
      value: PaymentSchemesStatus.Active.toString(),
    },
    {
      label: t(`PAYMENT_SCHEMES.TABLE.STATUS.INACTIVE`),
      value: PaymentSchemesStatus.Inactive.toString(),
    },
  ];

  const handleStatusChange = (
    value: string | number | (string | number)[] | null
  ) => {
    if (value !== null) {
      searchParams.set(
        'status',
        typeof value === 'string' ? value : value?.toString()
      );
      setSearchParams(searchParams);
    } else {
      searchParams.delete('status');
      setSearchParams(searchParams);
    }
  };

  return (
    <div className="payment-schemes__filters">
      <SearchInput
        pathMatch={match}
        placeholder={t('PAYMENT_SCHEMES.TABLE.FILTERS.NAME')}
      ></SearchInput>
      <div className="ph-dropdown">
        <Select
          placeholder={t('PAYMENT_SCHEMES.TABLE.FILTERS.STATUS') ?? ''}
          compact
          clearable
          onChange={(status) => handleStatusChange(status)}
          options={statusOptions}
          value={searchParams.get('status') ?? ''}
        ></Select>
      </div>
    </div>
  );
}
